export { jsAxios } from './axios.js';
